export enum StowageRuleTestScope {
    Unknown,
    Tank,
    Ship,
    AllAdjacentTanks,
    AnyAdjacentTanks,
    Cargo,
    CargoOperation,
}
